import { Overlay, OverlayRef, ScrollStrategy } from '@angular/cdk/overlay';

export function createBlockedOverlayScrollStrategy(overlay: Overlay): ScrollStrategy {
  return overlay.scrollStrategies.block();
}

export function createCloseOnScrollOverlayStrategy(document: Document): ScrollStrategy {
  return new CloseOnScrollOverlayStrategy(document);
}

class CloseOnScrollOverlayStrategy implements ScrollStrategy {
  private overlayRef?: OverlayRef;
  private enabled = false;
  private readonly handleScroll = (): void => this.overlayRef?.detach();

  constructor(private readonly document: Document) {}

  attach(overlayRef: OverlayRef): void {
    this.overlayRef = overlayRef;
  }

  enable(): void {
    if (this.enabled) return;

    this.document.addEventListener('scroll', this.handleScroll, true);
    this.enabled = true;
  }

  disable(): void {
    if (!this.enabled) return;

    this.document.removeEventListener('scroll', this.handleScroll, true);
    this.enabled = false;
  }
}
